// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileImageSection_wrapper__vMiFM"};